import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DateRangeSelector from '../../../Components/DateRangeSelector/DateRangeSelector';
import moment from 'moment-timezone';

export class WebinarsDateRangeSelector extends Component {
  static propTypes = {
    uniqueId: PropTypes.string.isRequired,
    isBig: PropTypes.bool.isRequired,
    mixpanelData: PropTypes.shape({
      action: PropTypes.string.isRequired,
      reportType: PropTypes.string
    }),
    getWebinars: PropTypes.func,
    reduced_webinars: PropTypes.object
  };

  render() {
    const { uniqueId, isBig, reduced_webinars, getWebinars, mixpanelData } = this.props;
    const { filter, fetching } = reduced_webinars;
    return (
      <DateRangeSelector
        reactDatesProps={{
          isOutsideRange: day =>
            day.isAfter(
              moment()
                .add(1, 'year')
                .endOf('day')
            ) ||
            day.isBefore(
              moment()
                .subtract(2, 'year')
                .endOf('day')
            )
        }}
        uniqueId={uniqueId}
        isBig={isBig}
        onApply={(startDate, endDate) => getWebinars(startDate, endDate)}
        fromDateTime={filter.fromTime}
        toDateTime={filter.toTime}
        defaultFromDateTime={filter.defaultFromDate}
        defaultToDateTime={filter.defaultToDate}
        disabled={fetching}
        futureDates={true}
        mixpanelData={mixpanelData}
      />
    );
  }
}

export default WebinarsDateRangeSelector;



// WEBPACK FOOTER //
// ./src/GoToWebinar/Webinars/Filters/WebinarsDateRangeSelector.js